module.exports = __webpack_public_path__ + "img/skype-logo-small.b0195d97.png";